import React from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

const Loading = (props) => {
  const className = classnames({
    [props.className]: props.className,
    loading: true
  })

  return (
    <div className={className}>
      <div className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>

      <p>{props.message}</p>
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string
}

Loading.defaultProps = {
  className: '',
  message: ''
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/common/loading.js